import { render } from "./SettingsMenu.vue?vue&type=template&id=556f336c&scoped=true&ts=true"
import script from "./SettingsMenu.vue?vue&type=script&lang=ts"
export * from "./SettingsMenu.vue?vue&type=script&lang=ts"

import "./SettingsMenu.vue?vue&type=style&index=0&id=556f336c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-556f336c"]])

export default __exports__